import axios from 'axios';
import { store } from '../store';
import { AUTH } from '../constants/siteConstants';
import { isEmpty } from 'lodash';
import getRecaptchaLoginRequest from '../utils/getRecaptchaLoginRequest';
import { urlLoginUsers } from '../actions/urls';
import { setCurrentUser } from '../actions/users/loginUser';
import { STATUS_CODE } from '../utils/utils';
import Session from '../utils/session';

let env = window.REACT_APP_ENV;
if (env === 'prod') env = '';

export const apiManagerRequest = axios.create({
  baseURL: ``,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

apiManagerRequest.interceptors.request.use(async (request) => {
  if (
    request?.data &&
    !request.headers.Authorization &&
    request.data.needsRecaptchaToken &&
    !isEmpty(request.data.captchaToken)
  ) {
    try {
      const recaptchaLoginRequest = getRecaptchaLoginRequest(request.data.captchaToken);
      const recaptchaLoginResponse = await axios.post(urlLoginUsers, recaptchaLoginRequest);
      const recaptchaLoginData = recaptchaLoginResponse.data;
      if (recaptchaLoginData?.token) {
        request.headers = {
          Authorization: `Bearer ${recaptchaLoginData?.token}`,
        };
      }

      delete request.data.needsRecaptchaToken;
      delete request.data.captchaToken;
      return request;
    } catch (error) {
      return {
        error: true,
        message: 'No pudimos hacer la petición',
        description: error,
      };
    }
  }

  return request;
});

apiManagerRequest.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === STATUS_CODE.HTTP_401_UNAUTHORIZED) {
      Session.remove();
      store.dispatch(
        setCurrentUser({
          statusCode: STATUS_CODE.HTTP_401_UNAUTHORIZED,
          error: true,
          message: AUTH.TOKEN_EXPIRED,
        }),
      );
    }
    return Promise.reject(error);
  },
);
